'use client'

import { Breadcrumb, Button, Divider, Typography } from 'antd'
import { useRouter, usePathname } from 'next/navigation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const { Text } = Typography

export const BreadcrumbBar = () => {
  const router = useRouter()
  const pathname = usePathname()

  // Hide component if we're on the home page
  if (pathname === '/home' || pathname === '/') {
    return null
  }

  // Get the last route name from the pathname
  const lastRouteName = pathname.split('/').pop() || 'Home'
  // Capitalize the first letter of the last route name
  const routeName =
    lastRouteName.charAt(0).toUpperCase() + lastRouteName.slice(1)

  // Format the route name: replace hyphens and numbers with spaces, apply title case
  const formatRouteToTitle = (route: string) => {
    // Replace hyphens and numbers with spaces
    const withSpaces = route.replace(/[-0-9]/g, ' ')
    // Split into words, capitalize first letter of each word, and join back
    return withSpaces
      .split(' ')
      .filter((word) => word.length > 0) // Remove empty strings
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  }

  const formattedRouteName = formatRouteToTitle(lastRouteName)

  return (
    <div className='block lg:hidden mt-4 w-full px-8 print:hidden'>
      <div className='block xl:hidden items-center justify-start gap-2'>
        <div className='flex flex-row items-center gap-2'>
          <Button
            type='link'
            onClick={() => router.push('/home')}
            className='cursor-pointer'
            style={{
              padding: '0px',
            }}
          >
            <FontAwesomeIcon
              icon='chevron-left'
              className='cursor-pointer text-primary'
              size='lg'
            />
            <Text style={{ color: '#06686b' }}>Back</Text>
          </Button>
          <Divider type='vertical' />
          <Breadcrumb
            items={[
              {
                title: 'Home',
                href: '/home',
                className: 'cursor-pointer text-primary',
                onClick: () => router.push('/home'),
              },
              {
                title: formattedRouteName,
                href: pathname,
                className: 'cursor-pointer text-primary',
                onClick: () => router.push(pathname),
              },
            ]}
          />
        </div>
      </div>
    </div>
  )
}
